import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  SpeedOutlined as OverviewIcon,
  MapOutlined as MapIcon,
} from '@mui/icons-material';
import { NavPanel, PanelGroup, PanelLink } from '../../components/layout/NavPanel';

// Both Dashboard screens share this so the panel does not change under you
// when you move between them.
const DashboardPanel: React.FC = () => {
  const { pathname } = useLocation();
  return (
    <NavPanel>
      <PanelGroup>
        <PanelLink to="/dashboard" exact icon={<OverviewIcon />} label="Overview" currentPath={pathname} />
        <PanelLink to="/coverage" icon={<MapIcon />} label="Coverage map" currentPath={pathname} />
      </PanelGroup>
    </NavPanel>
  );
};

export default DashboardPanel;
